import { useCachedImageSrc } from "../../lib/imageAssets.js";

export function CachedImage({ src, alt, loading = "lazy", cache = true, referrerPolicy = "no-referrer", ...imageProps }) {
  const cachedSrc = useCachedImageSrc(src, cache);
  return (
    <img
      {...imageProps}
      src={cachedSrc || src || undefined}
      alt={alt}
      loading={loading}
      referrerPolicy={referrerPolicy}
    />
  );
}
